// dateControls.js

import moment from 'moment/dist/moment';

const dateElement = document.getElementById('date');

let updateDateData = null;

// Wenn das Datumselement nicht vorhanden ist (z.B. Login-Seite), Modul still beenden.
if (dateElement !== null) {
  let updateDateTimeout = null;

  /**
   * Returns the current value of the date input, or today's date as fallback
   * if the field is empty or contains an invalid value.
   * Also corrects the input field itself so subsequent Prev/Next clicks work.
   */
  const _effectiveDate = () => {
    const parsed = moment(dateElement.value, 'YYYY-MM-DD', true); // strict parsing
    if (parsed.isValid()) {
      return parsed.format('YYYY-MM-DD');
    }
    const today = moment().format('YYYY-MM-DD');
    dateElement.value = today;
    return today;
  };

  /**
   * Returns true if the given date string (YYYY-MM-DD) is today or in the future.
   */
  const _isLiveDate = (date) => {
    return date >= moment().format('YYYY-MM-DD');
  };

  /**
   * Dispatches a dateChange event with the current (or fallback) date and a reason.
   *
   * @param {'date-change'|'visibility'|'interval'} reason
   */
  const dispatchDateChange = (reason) => {
    document.dispatchEvent(new CustomEvent('dateChange', {
      detail: {
        date: _effectiveDate(),
        reason,
      },
    }));
  };

  /**
   * Schedules the next automatic update (interval-based) and dispatches a dateChange event.
   * Accepts an explicit reason so that the first call after a user action can pass
   * 'date-change' or 'visibility' instead of 'interval'.
   *
   * @param {'date-change'|'visibility'|'interval'} reason
   */
  updateDateData = (reason = 'interval') => {
    if (updateDateTimeout !== null) {
      window.clearTimeout(updateDateTimeout);
      updateDateTimeout = null;
    }

    // Only schedule future interval ticks for live (today or future) dates.
    if (_isLiveDate(_effectiveDate())) {
      const currentSec = new Date().getSeconds();
      const secsUntilNextMinute = 60 - currentSec;
      const offset = 10 + Math.round(Math.random() * 10);
      const remain = secsUntilNextMinute + offset;

      updateDateTimeout = window.setTimeout(() => {
        updateDateData('interval');
      }, 1000 * remain);
    }

    dispatchDateChange(reason);
  };

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (updateDateTimeout !== null) {
        window.clearTimeout(updateDateTimeout);
        updateDateTimeout = null;
      }
    } else {
      updateDateData('visibility');
    }
  });

  document.getElementById('datePrevButton').addEventListener('click', (e) => {
    e.target.blur();
    dateElement.value = moment(_effectiveDate()).subtract(1, 'days').format('YYYY-MM-DD');
    updateDateData('date-change');
  });

  document.getElementById('dateNextButton').addEventListener('click', (e) => {
    e.target.blur();
    dateElement.value = moment(_effectiveDate()).add(1, 'days').format('YYYY-MM-DD');
    updateDateData('date-change');
  });

  dateElement.addEventListener('input', () => {
    updateDateData('date-change');
  });
}

export { updateDateData };
